export const designTokens = {
  colors: {
    // Purple color family
    purple: {
      50: '#FF68AD',
      100: '#723FFF26',
      200: '#D8B4FE',
      300: '#C084FC',
      400: '#A855F7',
      500: '#8458FC',
      600: '#9D79FD',
      700: '#5C3EB0',
      800: '#6711FF',
      900: '#30234C',
      950: '#3E2680',
      1000: '#B44BFE',
      1100: '#FF569D',
      1200: '#3C00A8',
      1300: '#B886FF',
    },

    // Lime/Green color family
    lime: {
      50: '#F9FFD0',
      100: '#F2FEB7',
      200: '#EBFE9E',
      300: '#E4FD85',
      400: '#DDFD6C',
      500: '#BCD75C',
      600: '#9AB24C',
      700: '#7F993E',
      800: '#6F7F36',
      900: '#2C3316',
      950: '#1F3315',
      1000: '#3E4338',
    },

    // Neutral/Grey color family
    neutral: {
      0: '#FFFFFF',
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#EEEFEF',
      400: '#BDBDBD',
      500: '#BBBDBF',
      600: '#9FA1A4',
      700: '#818283',
      800: '#595D62',
      850: '#424242',
      900: '#212121',
      925: '#1A1A1A',
      945: '#3E4145',
      950: '#06060C',
      975: '#0A0A0A',
      1000: '#000000',
      1100: '#F6F6F6',
      1200: '#22222F',
      1300: '#f9f9ff',
      1400: '#282828',
      1500: '#0F0D10',
    },

    // Base colors
    base: {
      black: '#000000',
      white: '#ffffff',
    },

    // Blue color family
    blue: {
      50: '#81ABF5',
      100: '#3EF4D6',
      200: '#BFDBFE',
      250: '#AAB2FF',
      300: '#180E2C',
      400: '#4b84fe',
      500: '#AAB2FF',
      550: '#2979FF',
      600: '#2563EB',
      700: '#1D4ED8',
      800: '#1E40AF',
      900: '#719FF0',
      1000: '#EEF0FF',
      1100: '#444663',
      1200: '#AFCBFF',
      1300: '#00B7FF',
    },

    // Green color family
    green: {
      50: '#F0FDF4',
      100: '#DCFCE7',
      200: '#BBF7D0',
      300: '#86EFAC',
      400: '#00C8AA',
      500: '#008807',
      600: '#16A34A',
      700: '#15803D',
      800: '#166534',
      900: '#14532D',
      950: '#008807',
      1000: '#00BFA5',
      1050: '#A3E6DC',
      1100: '#00C27B',
      1200: '#0DE77E',
    },

    // Yellow color family
    yellow: {
      50: '#FFFBEB',
      100: '#FEF3C7',
      200: '#FDE68A',
      300: '#FCD34D',
      400: '#FBBF24',
      500: '#F9C509',
      600: '#D97706',
      700: '#B45309',
      800: '#92400E',
      900: '#78350F',
      1000: '#F1C100',
      1100: '#DC9E00',
    },

    // Red color family
    red: {
      50: '#FEF2F2',
      100: '#FEE2E2',
      200: '#FECACA',
      300: '#FCA5A5',
      400: '#F87171',
      500: '#FE4B4B',
      600: '#FF6464',
      700: '#DC2626',
      800: '#EC0065',
      900: '#7F1D1D',
      950: '#B50000',
      1000: '#FE4B4B',
    },

    // Orange color family
    orange: {
      50: '#FFF7ED',
      100: '#FFEDD5',
      200: '#FED7AA',
      300: '#FDBA74',
      400: '#FB923C',
      500: '#FF7300',
      550: '#FF811A',
      600: '#FF7B30',
      700: '#C2410C',
      800: '#9A3412',
      900: '#7C2D12',
      1000: '#FF7300',
    },

    pink: {
      50: '#fdf2f9',
      100: '#fbe8f5',
      200: '#fad0eb',
      300: '#f7aada',
      400: '#f076c0',
      500: '#e959ac',
      600: '#d62c86',
      700: '#b91d6b',
      800: '#991b58',
      900: '#801b4c',
      950: '#4e092a',
      1000: '#FF19A7',
    },

    turquoise: {
      50: '#edfdfe',
      100: '#d1f9fc',
      200: '#a8f1f9',
      300: '#5ee3f2',
      400: '#2ad0e6',
      500: '#0eb3cc',
      600: '#0f8fab',
      700: '#13738b',
      800: '#195d71',
      900: '#194e60',
      950: '#0a3342',
    },

    grape: {
      50: '#f3effe',
      100: '#e7e1fe',
      200: '#d5c9fc',
      300: '#bda8f9',
      400: '#ab85f4',
      500: '#9f68ec',
      600: '#944cdf',
      700: '#843dc5',
      800: '#6a349f',
      900: '#56317e',
      950: '#3e2359',
    },

    violet: {
      50: '#edf1ff',
      100: '#EAE2FF',
      200: '#c4d0ff',
      300: '#a0b0ff',
      400: '#7c87ff',
      500: '#5b5df9',
      600: '#483dee',
      700: '#3d2fd3',
      800: '#3229aa',
      900: '#2d2986',
      950: '#1c184e',
      1000: '#E6DDFF',
    },
  },

  typography: {
    fontFamily: {
      primary:
        '"General Sans", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      secondary: '"Roboto Mono", "Monaco", "Courier New", monospace',
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      boldItalic: 700,
    },
    fontSizes: {
      // Desktop font sizes (current)
      h1: '3.5rem',
      h2: '3rem',
      h3: '2.625rem',
      h4: '2.25rem',
      h5: '2rem',
      h6: '1.5rem',
      subtitle1: '1.25rem',
      subtitle2: '1.125rem',
      body1: '1rem',
      body2: '0.875rem',
      caption: '0.75rem',

      // Mobile font sizes (from Figma mobile design)
      mobile: {
        h1: '2.25rem', // 36px
        h2: '2rem', // 32px
        h3: '1.75rem', // 28px
        h4: '1.5rem', // 24px
        h5: '1.375rem', // 22px
        h6: '1.1875rem', // 19px
        subtitle1: '1.125rem', // 18px
        subtitle2: '1rem', // 16px
        body1: '0.875rem', // 14px
        body2: '0.75rem', // 12px
        caption: '0.75rem', // 12px
      },

      // Utility sizes
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
    },
    letterSpacing: {
      h1: '-0.02em',
      h2: '-0.02em',
      h3: '0em',
      h4: '0.01em',
      h5: '0em',
      h6: '0.01em',
      subtitle1: '0.01em',
      subtitle2: '0.01em',
      body1: '0.03em',
      body2: '0.03em',
      caption: '0.03em',

      // Mobile letter spacing (from Figma mobile design)
      mobile: {
        h1: '-0.031em', // -0.5px
        h2: '-0.031em', // -0.5px
        h3: '0em', // 0px
        h4: '0.016em', // 0.25px
        h5: '0em', // 0px
        h6: '0.009em', // 0.15px
        subtitle1: '0.009em', // 0.15px
        subtitle2: '0.009em', // 0.15px
        body1: '0.031em', // 0.5px
        body2: '0.031em', // 0.5px
        caption: '0.025em', // 0.4px
      },
    },
    lineHeights: {
      h1: 1.14,
      h2: 1.17,
      h3: 1.19,
      h4: 1.22,
      h5: 1.25,
      h6: 1.33,
      subtitle1: 1.4,
      subtitle2: 1.4,
      body1: 1.5,
      body2: 1.5,
      caption: 1.4,
    },
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    '2xl': 48,
    '3xl': 64,
  },

  borderRadius: {
    none: 0,
    xs: 2,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 20,
    '3xl': 24,
    '4xl': 30,
    '5xl': 40,
    full: 9999,
  },

  elevation: {
    none: 'none',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },

  button: {
    borderRadius: 32,
    height: {
      sm: 32,
      md: 36,
      lg: 42,
      xl: 48,
    },
    shadow: {
      hover: '0 2px 8px',
      active: '0 1px 4px',
      opacity: {
        hover: 0.25,
        active: 0.3,
      },
    },
    typography: {
      sm: {
        fontSize: '0.875rem', // 14px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.07px',
      },
      md: {
        fontSize: '1rem', // 16px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.08px',
      },
      lg: {
        fontSize: '1rem', // 16px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.08px',
      },
      xl: {
        fontSize: '1.125rem', // 18px
        fontWeight: 500,
        lineHeight: 1, // 100%
        letterSpacing: '0.027px',
      },
    },
  },

  textField: {
    borderRadius: 24,
    height: {
      sm: 36,
      md: 48,
    },
    typography: {
      sm: {
        fontSize: '0.875rem', // 14px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.07px',
      },
      md: {
        fontSize: '1rem', // 16px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.08px',
      },
      lg: {
        fontSize: '1rem', // 16px
        fontWeight: 500,
        lineHeight: 1.5, // 150%
        letterSpacing: '0.08px',
      },
      xl: {
        fontSize: '1.125rem', // 18px
        fontWeight: 500,
        lineHeight: 1, // 100%
        letterSpacing: '0.027px',
      },
    },
    shadow: {
      hover: '0 2px 8px',
      active: '0 1px 4px',
      opacity: {
        hover: 0.25,
        active: 0.3,
      },
    },
  },

  opacity: {
    hover: 0.04,
    selected: 0.08,
    disabled: 0.12,
    focus: 0.12,
    bg: 0.1,
    secondHover: 0.2,
  },
};
